import styles from "./PageContentWrapper.module.scss";

const PageContentWrapper = ({ children }) => {
  return <div className={styles.wrapper}>{children}</div>;
};

export default PageContentWrapper;
